module.exports = __webpack_public_path__ + "media/images/new-logo-c106f486903d181bf09bb4cb1973cefe.png";